import { createFileRoute } from "@tanstack/react-router";
import { UserButton } from "@clerk/clerk-react";
import { AppShell, Box, Burger, Group } from "@mantine/core";
import { ConnectDeviceModal } from "@/components/integrated-devices/connect-device-modal";
import { LogoTitle } from "@/components/logo-title";
import { Navigation } from "@/components/navigation";
import { useNavigationDisclosure } from "@/hooks/use-navigation-disclosure";
import { Outlet } from "@tanstack/react-router";
import { Anchor } from "@/components/anchor";

export const Route = createFileRoute("/_authenticated/_subscribed/_main")({
  component: RouteComponent,
});

function RouteComponent() {
  const [opened, { toggle }] = useNavigationDisclosure();

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 250,
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
    >
      <AppShell.Header p="xs">
        <Group justify="space-between">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          <Anchor to="/home" c="unset" underline="never">
            <LogoTitle />
          </Anchor>
          <Group>
            <ConnectDeviceModal size="button" />
            <UserButton />
          </Group>
        </Group>
      </AppShell.Header>
      <AppShell.Navbar py="md">
        <Navigation />
      </AppShell.Navbar>
      <AppShell.Main>
        <Box p="lg">
          <Outlet />
        </Box>
      </AppShell.Main>
    </AppShell>
  );
}
